import { type Framework } from '@toeverything/infra';

import { DocsService } from '../doc';
import { WorkspaceLocalState, WorkspaceScope } from '../workspace';
import { DocSwitcherService } from './services/doc-switcher';

export { DocSwitcherService };
export { DocSwitcherContainer } from './views/doc-switcher-container';
export { useTrackDocVisits } from './views/use-track-doc-visits';

export function configureDocSwitcherModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(DocSwitcherService, [WorkspaceLocalState, DocsService]);
}
